import { userService } from '@/core/services/user-service';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { DataGrid } from 'devextreme-react';
import CustomStore from 'devextreme/data/custom_store';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const UserList = () => {
    const dataGridRef = useRef<DataGrid>(null);
    const [mainStore] = useState(new CustomStore({
        key: ['id'],
        load: userService.userList,
        byKey: async (key, loadOptions: any) => {
            let returnObject = null;
            if (key) {
                loadOptions.filter = ["id", "=", key];
                const objectsByID = (await userService.userList(loadOptions))
                returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
            }
            return returnObject
        },
        useDefaultSearch: true
    }));
    const navigate = useNavigate();
    const goToEdit = (id: string) => {
        navigate(`/user-definition/${id}`, { state: { id: id } })
    }
    return (
        <>
            <DataGridWrapper
                props={{ id: 'user-list', ref: dataGridRef, wordWrapEnabled: true }}
                permissonCode='User.User'
                datasource={mainStore}
                editingConfig={{ allowUpdating: true }}
                filterVisible={true}
                headerFilterVisible={true}
                pagerVisible={true}
                enableCustomToolbarContent={true}
                navigateNewRecordPath='/user-definition'
                columns={[
                    {
                        dataField: 'userName',
                        caption: 'Kullanıcı Adı',
                        allowSearch: true,
                    },
                    {
                        dataField: 'email',
                        caption: 'Email',
                        allowSearch: true,
                    },
                    {
                        dataField: 'accountName',
                        caption: 'Account',
                        allowSearch: true,
                    }
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: (e: any) => goToEdit(e.row?.data.id),
                    },
                ]}
            />

        </>

    )
}
export default UserList